import { render, staticRenderFns } from "./addCourseAuth.vue?vue&type=template&id=cc6b9286&scoped=true"
import script from "./addCourseAuth.vue?vue&type=script&lang=js"
export * from "./addCourseAuth.vue?vue&type=script&lang=js"
import style0 from "./addCourseAuth.vue?vue&type=style&index=0&id=cc6b9286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6b9286",
  null
  
)

export default component.exports